import React from "react";
import Datepicker from "react-datepicker";
import PropTypes from "prop-types";
import { FaCalendarAlt } from "react-icons/fa";
import { dMMMyyyy } from "../../utils/constants/appConstants";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";

const PaymentReportDatePicker = ({ onChange, selected }) => {
  return (
    <div className={Style.datepickerWithicon}>
      <Datepicker
        className={`${Style.datepicercustom} ${Style.fundedRepayDate}`}
        selected={selected}
        onChange={onChange}
        dateFormat={dMMMyyyy}
      />
      <span>
        <FaCalendarAlt />
      </span>
    </div>
  );
};
PaymentReportDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(Date)
};

export default PaymentReportDatePicker;
